module.exports = __webpack_public_path__ + "img/alkaline.a111dc5e.jpg";